import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

const rootElement = document.getElementById("root")!;
rootElement.replaceChildren();

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
